'use client';

import React, { createContext, useContext, useMemo } from 'react';
import { ALL_BREAKPOINTS, isHiddenOn, type Breakpoint } from './breakpoints';

/** The breakpoints a block is actually shown on — its own hideMobile/hideTablet/hideDesktop and
 *  every enclosing block's. Hiding is CSS only (`.block-hide-*`), so a hidden block still mounts;
 *  this is how it can tell (see usePageControl in blocks/ProductBlocks.tsx). */
const VisibleBreakpointsContext = createContext<readonly Breakpoint[]>(ALL_BREAKPOINTS);

export function VisibleBreakpointsProvider({ styles, children }: { styles: any; children: React.ReactNode }) {
    const parent = useContext(VisibleBreakpointsContext);
    const hideMobile = Boolean(styles?.hideMobile);
    const hideTablet = Boolean(styles?.hideTablet);
    const hideDesktop = Boolean(styles?.hideDesktop);
    const visible = useMemo(
        () => parent.filter((bp) => !isHiddenOn({ hideMobile, hideTablet, hideDesktop }, bp)),
        [parent, hideMobile, hideTablet, hideDesktop],
    );
    return <VisibleBreakpointsContext.Provider value={visible}>{children}</VisibleBreakpointsContext.Provider>;
}

export function useVisibleBreakpoints(): readonly Breakpoint[] {
    return useContext(VisibleBreakpointsContext);
}
